export default __webpack_public_path__ + "static/media/Group 1925.38dbfb75.svg";